import { IGetFuncionariosDropDownUseCase } from "../../../presentation/useCases/read/get_funcionarios_dropdown_use_case";
import { FuncionarioDropDown } from "../../models/funcionario_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

export class GetFuncionariosDropDownUseCase implements IGetFuncionariosDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) {}

  async getFuncionariosDropDown(
    filtrarCentroCusto?: boolean,
    includeCantBeSelected?: boolean,
    somenteComBiometria?: boolean,
    idCargo?: number,
  ): Promise<FuncionarioDropDown[]> {
    return await this.repository.getFuncionariosDropDown(
      filtrarCentroCusto,
      includeCantBeSelected,
      somenteComBiometria,
      idCargo,
    );
  }
}
